<div class="header">
    <div>
        
    </div>

    <div class="menu">
        <button (click)="toggle()" mat-button>
            <mat-icon>menu</mat-icon>
        </button>
    </div>
</div>